import { Theme, darken } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useReferralInfoStyles = makeStyles()(({ shape, spacing, palette, breakpoints }: Theme) => ({
  mobileH5: {
    [breakpoints.down('md')]: {
      fontSize: 20,
    },
  },
  mobileH6: {
    [breakpoints.down('md')]: {
      fontSize: 18,
    },
  },
  mobileSubtitle: {
    [breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
  middleText: {
    [breakpoints.down('md')]: {
      padding: spacing(0.5, 0, 1, 0),
    },
  },
  leftCard: {
    flexGrow: 1,
  },
  linkBox: {
    backgroundColor: palette.common.white,
    borderRadius: shape.borderRadius,
    margin: spacing(2),
    padding: spacing(1),
    textAlign: 'center',

    [breakpoints.down('md')]: {
      backgroundColor: palette.background.default,
    },
  },
  rewardsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: palette.common.white,
    borderRadius: shape.borderRadius,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    margin: spacing(2, 0.5),
    padding: spacing(1),

    [breakpoints.down('md')]: {
      backgroundColor: palette.background.default,
    },
  },
  rewardAmount: {
    color: palette.success.main,
    marginBottom: 'auto',
    marginTop: 'auto',
  },
  textLight: {
    color: palette.secondary.light,
  },
  button: {
    color: palette.common.white,
    backgroundColor: palette.proceed.main,
    transition: 'unset',
    '&:hover': {
      backgroundColor: darken(palette.proceed.main, 0.25),
      '@media (hover: none)': {
        backgroundColor: palette.proceed.main,
      },
    },
  },
  buttonCopied: {
    color: palette.common.white,
    backgroundColor: palette.success.main,
    transition: 'unset',
    '&:hover': {
      backgroundColor: darken(palette.success.main, 0.25),
      '@media (hover: none)': {
        backgroundColor: palette.success.main,
      },
    },
  },
}));
